import { Switch } from 'antd';
import useFooterChart from './useFooterChart';
import './styles.scss';

/**
 * Renders the footer of the R-R heatmap holding the toggle that hides already reviewed cells. Binds the switch checked state and change handler to isHideReviewedCell and onChangeHideReviewed from useFooterChart.
 *
 * @returns The heatmap footer containing the hide-reviewed-cell switch.
 */
const FooterChart = () => {
  const { isHideReviewedCell, onChangeHideReviewed } = useFooterChart();

  return (
    <div className="footer-chart">
      <div className="hide-reviewed">
        <Switch
          id="hide-reviewed-cell-btn"
          aria-labelledby="hide-reviewed-cell-label"
          size="small"
          checked={isHideReviewedCell}
          onChange={onChangeHideReviewed}
        />
        <span id="hide-reviewed-cell-label" className="switch-label">
          Hide reviewed cell
        </span>
      </div>
    </div>
  );
};

export default FooterChart;
